import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import CommonFilters from "components/filters-forms/components/CommonFilters"
import TagsAutocomplete from "components/filters-forms/components/TagsAutocomplete"
import { useFiltersFormStyles } from "components/filters-forms/filters-form-styles"
import useCurrent from "lib/use-current"
import { useStateMachine } from "little-state-machine"
import { updateSessionsFilters, defaultSessionsFiltersStore } from "stores/sessions-filters-store"

interface ISessionsFiltersForm {}

const SessionsFiltersForm = (_props: ISessionsFiltersForm) => {
  const { actions, state } = useStateMachine({ updateSessionsFilters })

  const { classes } = useFiltersFormStyles()

  const onClear = () => {
    actions.updateSessionsFilters({ ...defaultSessionsFiltersStore })
  }

  const isDirty = Object.keys(defaultSessionsFiltersStore).some((k) => {
    // @ts-ignore PT - #180597146
    if (!state.sessionsFiltersStore[k]) {
      return false
      // @ts-ignore PT - #180597146
    } else if (Array.isArray(state.sessionsFiltersStore[k])) {
      return (
        // @ts-ignore PT - #180597146
        state.sessionsFiltersStore[k].length !== defaultSessionsFiltersStore[k].length ||
        // @ts-ignore PT - #180597146
        state.sessionsFiltersStore[k].some(
          // @ts-ignore PT - #180597146
          (fv: any, i: number) => fv !== defaultSessionsFiltersStore[k][i],
        )
      )
    } else {
      // @ts-ignore PT - #180597146
      return state.sessionsFiltersStore[k] !== defaultSessionsFiltersStore[k]
    }
  })

  // @ts-ignore
  const { config: providerConfig } = useCurrent()

  return (
    <Box className={classes.root}>
      {isDirty && (
        <Box>
          <Button
            className={classes.clearAllButton}
            onClick={onClear}
            variant="text"
            color="primary">
            Clear All
          </Button>
        </Box>
      )}

      <TagsAutocomplete action={actions.updateSessionsFilters} state={state.sessionsFiltersStore} />

      {!!providerConfig.show_session_filters && (
        <CommonFilters action={actions.updateSessionsFilters} state={state.sessionsFiltersStore} />
      )}
    </Box>
  )
}

export default SessionsFiltersForm
